var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M19.5 16.5h-16l-.956-3.825a2 2 0 0 1 .611-1.98L4.5 9.5l1-4s3-1 6-1 6 1 6 1l1 4 1.345 1.195a2 2 0 0 1 .611 1.98zm-13 0h-3V18a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm10 0h3V18a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5zm-12-7h14m-11 5h-.573a2.312 2.312 0 0 1-2.066-1.276.5.5 0 0 1 .448-.724H7.5a1 1 0 1 1 0 2zm8.573 0H15.5a1 1 0 1 1 0-2h2.191a.5.5 0 0 1 .447.724 2.31 2.31 0 0 1-2.065 1.276z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgCar as ReactComponent };
export default __webpack_public_path__ + "b9c211d6134e52096578fc53f555eada.svg";